import { FlyerTask, FlyerStatus } from './types/flyer';
import { Task, TaskStatus } from '../../types';

export class FlyerAdapter {
  static adaptTasks(tasks: FlyerTask[]): Task[] {
    console.log('🔄 FlyerAdapter.adaptTasks - start', { tasks });
    console.log('📊 Tasks length:', tasks?.length);
    console.log('📋 Tasks structure:', JSON.stringify(tasks, null, 2));

    if (!Array.isArray(tasks)) {
      console.warn(
        '❌ FlyerAdapter: Invalid response format, expected array',
        tasks,
      );
      return [];
    }

    const adaptedTasks = tasks
      .filter((task) => {
        console.log('🔍 FlyerAdapter: Processing task:', task);

        // Показываем все задания, даже без деталей
        return true;
      })
      .map((task) => {
        console.log('task312', task);
        const details = task.details_flyer;
        console.log('detailsFlyer', details);
        // Определяем статус задания
        const mapFlyerStatusToTaskStatus = (
          status: FlyerStatus,
        ): TaskStatus => {
          switch (status) {
            case FlyerStatus.Waiting:
              return 'IN_PROGRESS';
            case FlyerStatus.NotStarted:
            case FlyerStatus.Active:
              return 'NOT_STARTED';
            case FlyerStatus.Claim:
              return 'DONE';
            case FlyerStatus.Check:
              return 'CHECK';
            case FlyerStatus.Done:
              return 'CLAIMED';
            default:
              return 'NOT_STARTED';
          }
        };

        const status = mapFlyerStatusToTaskStatus(task.status as FlyerStatus);
        const isCompleted = status === 'CLAIMED';
        const isInProgress = status === 'IN_PROGRESS';

        const setButtonText = (status: string): string => {
          if (
            status === 'NOT_STARTED' &&
            task.details_flyer.task === 'give boost'
          ) {
            return 'Голосовать';
          }

          switch (status) {
            case 'CLAIMED':
              return 'Собрать';
            case 'DONE':
              return 'Выполнено';
            case 'CHECK':
              return 'Проверить';
            case 'IN_PROGRESS':
              return 'Проверка';
            case 'NOT_STARTED':
              return 'Выполнить';
            default:
              return 'Выполнить';
          }
        };

        // Создаем объект задания с безопасной обработкой деталей
        const taskObject: Task = {
          id: task.id || 0,
          title: details?.name || `Flyer Task ${task.id}`,
          type: 'sponsors',
          rewards: {
            stars: task.rewards?.stars || 0,
          },
          status,
          buttonText: setButtonText(status),
          link: isCompleted || isInProgress ? '' : details?.link || '',
          provider: 'FLYER',
          visibility: true,
          taskType: task.details_flyer.task,
          icon: task.details_flyer.photo,
        };

        console.log('✅ FlyerAdapter: Task rewards:', taskObject.rewards);
        console.log(
          '✅ FlyerAdapter: Task has rewards:',
          (taskObject.rewards?.stars || 0) > 0,
        );

        console.log('✅ FlyerAdapter: Created task object:', taskObject);
        return taskObject;
      });

    console.log('✅ FlyerAdapter.adaptTasks - result', adaptedTasks);
    return adaptedTasks;
  }
}
